import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ContactService } from "./contact.service";
import { Settings } from "@common/core/config/settings.service";
import { BehaviorSubject } from "rxjs";
import { Toast } from "@common/core/ui/toast.service";

@Component({
  selector: "contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsComponent implements OnInit {
  public loading$ = new BehaviorSubject<boolean>(false);
  FormData: FormGroup;
  public errors$ = new BehaviorSubject({});

  constructor(
    private contact: ContactService, 
    private builder: FormBuilder,
    public settings: Settings,
    private toast: Toast
  ) {}

  ngOnInit(): void {
    this.FormData = this.builder.group({
      firstName: new FormControl("", [Validators.required]),
      lastName: new FormControl("", [Validators.required]),
      email: new FormControl("", [
        Validators.compose([Validators.required, Validators.email]),
      ]),
      phone: new FormControl("", [Validators.required]),
      comment: new FormControl("", [Validators.required]),
    });
  }

  get contactFormControl() {
    return this.FormData.controls;
  }

  onSubmit() {
    
    this.loading$.next(true);
    this.contact.generateZohoAccessToken(this.FormData.value).subscribe(
      (response) => {

        this.FormData.reset();
        this.loading$.next(false);
        this.errors$.next({});
        this.toast.open(
          'Thank you for contacting us. Our executive will reach out to you shortly.',
          {
            duration: 10000
          }
        );

        // this.contact.PostMessage(FormData).subscribe(
        //   (response) => {
        //     location.href = "https://mailthis.to/confirm";
        //   },
        //   (error) => {
        //     console.warn(error.responseText);
        //     console.log({ error });
        //   }
        // );

      },
      (error) => {
        console.log(error);
        this.loading$.next(false);

        this.errors$.next(error.errors)

        if (error.status === 400 && error.message) {
          this.toast.open(error.message);
        }
      }
    );
  }
}
